import { Link } from 'react-router-dom';

import { Card } from '../components/Card.js';

const UPDATED = '2026-10-20';

/**
 * 用户协议（公开页，无需登录）。
 * 内容纪律：条款与平台真实能力对齐——「平台可下架虚假信息」对应管理后台真实存在的禁用能力，
 * 「数据可导出可删除」对应设置页真实存在的两个入口，不写做不到的承诺。
 */
export function TermsPage() {
  return (
    <div className="auth-shell">
      <div className="landing-wrap">
        <Card title="用户协议" subtitle={`最后更新：${UPDATED} · 版本 v1.0`}>
          <div className="legal-doc">
            <h3>一、服务说明</h3>
            <p>
              本平台当前处于原型阶段（持续迭代中），功能与界面可能随时调整或下线。赛事时间、规则、奖项等信息以各赛事
              主办方官方发布为准，本平台不对第三方信息的准确性作担保。
            </p>

            <h3>二、账号与安全</h3>
            <ul>
              <li>你需要对账号密码的保密负责；发现登录异常请立即修改密码；</li>
              <li>不要将账号出借、出售或转让给他人，由此产生的后果由账号持有人承担。</li>
            </ul>

            <h3>三、你的内容与责任</h3>
            <ul>
              <li>你录入的技能、时间、简介、候选人与队伍信息应当真实、准确；</li>
              <li>你对自己发布的内容负责。发布虚假信息、冒充他人、恶意干扰匹配秩序的行为，平台有权下架相关内容、禁用账号，并保留追究法律责任的权利。</li>
            </ul>

            <h3>四、平台治理</h3>
            <p>
              平台管理员可在管理后台执行账号禁用、角色调整等操作，所有操作留有审计日志。如认为处理有误，
              可通过站内反馈申诉，我们会复核并回复。
            </p>

            <h3>五、数据与隐私</h3>
            <p>
              平台如何收集、使用与保护你的数据，详见《隐私政策》。简言之：数据最小化、不共享、可导出、可删除。
            </p>

            <h3>六、知识产权</h3>
            <p>
              你录入的内容归你所有；平台的代码、设计、算法与文档归平台所有。匹配排序结果仅供组队参考，
              不构成任何形式的承诺或保证。
            </p>

            <h3>七、免责声明</h3>
            <ul>
              <li>匹配结果由算法基于你填写的信息计算，信息不完整时结果可能失真；</li>
              <li>因不可抗力、网络故障或第三方服务（含 AI 服务商）不可用造成的服务中断，平台不承担由此产生的直接损失；</li>
              <li>你与其他用户之间的线下合作与纠纷由双方自行协商解决，平台不参与、不担保。</li>
            </ul>

            <h3>八、协议变更</h3>
            <p>
              重大变更会通过站内公告提示，并更新本页顶部的「最后更新」日期；继续使用即视为接受更新后的协议。
            </p>

            <p className="muted small">
              返回<Link to="/">首页</Link>，或查看<Link to="/privacy">《隐私政策》</Link>。
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
